module.exports = __webpack_public_path__ + "0613c488cf7911af70db821bdd05dfc4.ttf";